import { Navigate } from "react-router-dom";
import { isLogin } from "../utils/utils";

const ProtectedRoutes = ({ children }) => {
  return (
    <>
      <>
        {isLogin() && <>{children} </>}
        {!isLogin() && <Navigate to="/login" />}
      </>
    </>
  );
};

export default ProtectedRoutes;
